import React from 'react';

export function Spinner({ size = 'md', label = 'Caricamento...' }) {
  const s = size === 'sm' ? 18 : size === 'lg' ? 40 : 26;
  return (
    <div className="spinner-wrap" aria-live="polite" aria-label={label}>
      <svg className="spinner" width={s} height={s} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2.5" strokeOpacity="0.2" />
        <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      {label && <span className="spinner-label">{label}</span>}
    </div>
  );
}

export function ErrorBox({ message, onRetry }) {
  return (
    <div className="error-box" role="alert">
      <span className="error-icon">⚠</span>
      <p className="error-msg">{message || 'Si è verificato un errore.'}</p>
      {onRetry && (
        <button className="btn btn-ghost btn-sm" onClick={onRetry}>
          Riprova
        </button>
      )}
    </div>
  );
}

export function EmptyState({ icon = '📭', title, subtitle }) {
  return (
    <div className="empty-state">
      <span className="empty-icon">{icon}</span>
      {title && <p className="empty-title">{title}</p>}
      {subtitle && <p className="empty-subtitle">{subtitle}</p>}
    </div>
  );
}

export function Badge({ children, variant = 'default' }) {
  return <span className={`badge badge-${variant}`}>{children}</span>;
}
